<div class="comments-container">
  <!-- Debug Information -->


  <!-- Write Comment Section -->
  <div class="comment-input" *ngIf="!isEditorExpanded" (click)="expandEditor()">
    <div class="comment-input-wrapper">
      <app-avatar [userKey]="currentUser?.key || null" [large]="false"></app-avatar>
      <div class="placeholder">Write a comment...</div>
    </div>
  </div>

  <!-- Expanded Editor -->
  <div class="editor-container" *ngIf="isEditorExpanded" [class.reply-mode]="replyingTo">
    <div class="editor-header">
      <app-avatar [userKey]="currentUser?.key || null" [large]="false"></app-avatar>
      <span class="user-name">{{ currentUser?.name }}</span>
      <div class="reply-info" *ngIf="replyingTo">
        Replying to {{ replyingTo.senderName }}
        <button mat-icon-button (click)="replyingTo = null">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    
    <app-html-editor
      #editor
      [(ngModel)]="newComment"
      [ngModelOptions]="{standalone: true}"
      [uploadFolder]="uploadFolder"
      [boardId]="boardKey"
      (pauseSave)="onPauseSave($event)"
      (userMentioned)="onUserMentioned($event)"
      [users]="users"
      [codes]="codes">
    </app-html-editor>
    
    <div class="editor-actions">
      <div class="comment-type-toggle">
        <button mat-button
          [class.active]="commentType === 'bug'"
          (click)="commentType = commentType === 'bug' ? 'comment' : 'bug'">
          <mat-icon>bug_report</mat-icon>
          Bug
        </button>
        <button mat-button
          [class.active]="commentType === 'enhancement'"
          (click)="commentType = commentType === 'enhancement' ? 'comment' : 'enhancement'">
          <mat-icon>lightbulb_outline</mat-icon>
          Enhancement
        </button>
      </div>
      <div class="button-group">
        <button mat-button (click)="cancelEditing()">Cancel</button>
        <app-loading-button
          [loading]="isUploading"
          [disabled]="!newComment.trim()"
          color="primary"
          variant="raised"
          (buttonClick)="saveComment()">
          {{ editingComment ? 'Update' : 'Save' }}
        </app-loading-button>
      </div>
    </div>
  </div>

  <!-- Comments List -->
  <div class="comments-list">
    <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" diameter="40"></mat-progress-spinner>
    
    <div *ngIf="!isLoading && comments?.length === 0" class="no-comments">
      No comments yet. Be the first to add a comment!
    </div>
    
    <div class="comment-item" *ngFor="let comment of comments; trackBy: trackByKey">
    
      <!-- Reply Thread Line -->
      <div class="reply-line" *ngIf="comment.replyTo"></div>
      
      <div class="comment-content" [class.is-reply]="comment.replyTo">
        <!-- Avatar -->
        <app-avatar [userKey]="comment.senderKey" [large]="false"></app-avatar>
        
        <!-- Comment Body -->
        <div class="comment-body">
          <div class="comment-header">
            <span class="sender-name">{{ comment.senderName }}</span>
            <span class="comment-type-badge bug" *ngIf="comment.commentType === 'bug'">
              <mat-icon>bug_report</mat-icon> Bug
            </span>
            <span class="comment-type-badge enhancement" *ngIf="comment.commentType === 'enhancement'">
              <mat-icon>lightbulb_outline</mat-icon> Enhancement
            </span>
            <span class="comment-date">{{ comment.createdAt |  date:'MMM d, y, h:mm a' }}</span>
          </div>
          
          <!-- Reply Reference -->
          <div class="reply-reference" *ngIf="comment.replyTo">
            Replying to {{ comment.replyTo.senderName }}
          </div>
          
          <!-- Comment Message -->
          <div class="message comment-message" [innerHTML]="cleanMessages[comment.key] || comment.message"></div>
          <app-link-preview [content]="comment.message" (previewUrls)="onPreviewUrls(comment, $event)"></app-link-preview>

          <!-- Comment Actions -->
          <div class="comment-actions">
            <button mat-button (click)="reply(comment)">Reply</button>
            <ng-container *ngIf="comment.senderKey === currentUser?.key">
              <button mat-button (click)="startEditing(comment)">Edit</button>
              <button mat-button color="warn" (click)="deleteComment(comment)">Delete</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 